module.exports = __webpack_public_path__ + "static/media/ht.ac7fed1d.svg";